import { render, staticRenderFns } from "./anchorDetail.vue?vue&type=template&id=19416b5a&scoped=true&"
import script from "./anchorDetail.vue?vue&type=script&lang=js&"
export * from "./anchorDetail.vue?vue&type=script&lang=js&"
import style0 from "./anchorDetail.vue?vue&type=style&index=0&id=19416b5a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19416b5a",
  null
  
)

export default component.exports